var __jsx = React.createElement;
import React from 'react';
import SpacerElement from './style';
import { jsx as _jsx } from "react/jsx-runtime";
var Spacer = function Spacer(_ref) {
  var grow = _ref.grow,
    width = _ref.width,
    height = _ref.height,
    display = _ref.display;
  return /*#__PURE__*/_jsx(SpacerElement, {
    grow: grow,
    width: width,
    height: height,
    display: display
  });
};
Spacer.defaultProps = {
  grow: false,
  width: null,
  height: null,
  display: 'block'
};
export default Spacer;